<!--公用组件：actionsheet组件
    @dengli
    @date 2018年11月8日
    props
        - actions 数组，同mint-ui用法一致,包含名称及一个需要执行的函数
    调用示例
        <actionsheet :actions=“actions”/>
-->
<template>
    <div class="actionsheet" v-show="showWrapper">
        <transition enter-active-class="animated faster slideInUp" leave-active-class="animated faster slideOutDown">
            <div class="actionsheet-content" v-show="show">
                <div class="sheet-wrapper">
                    <ul class="actionsheet-list">
                        <li
                            class="actionsheet-listitem border-top"
                            v-for="(item, index) in actions"
                            :key="item.id"
                            @click.stop="itemClick(item, index)"
                        >
                            {{ item.name }}
                        </li>
                    </ul>
                </div>
                <v-touch @tap="close"> <div class="actionsheet-button">取消</div> </v-touch>
            </div>
        </transition>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated faster fadeOut">
            <div class="actionsheet-modal" v-show="show" @click="close"></div>
        </transition>
    </div>
</template>
<style lang="scss" scoped>
.actionsheet {
    width: 100%;
    text-align: center;
    .actionsheet-content {
        position: absolute;
        bottom: 0;
        z-index: 3;
        .sheet-wrapper {
            position: relative;
            background: rgba(255, 255, 255, 1);
            width: 17.85rem;
            border-radius: 0.57rem;
            margin: 0 auto 0.3rem auto;
            box-sizing: border-box;
            overflow: hidden;
            opacity: 0.9;
            .actionsheet-list {
                max-height: 20.72rem;
                overflow: scroll;
                -webkit-overflow-scrolling: touch;
                .actionsheet-listitem {
                    padding: 0 1rem;
                    height: 2.59rem;
                    font-size: 0.9rem;
                    color: rgba(40, 120, 255, 1);
                    line-height: 2.59rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .actionsheet-listitem:active {
                    background-color: #f0f0f0;
                }
            }
        }
        .actionsheet-button {
            margin: 0 0.45rem 0.48rem 0.45rem;
            width: 17.85rem;
            height: 2.59rem;
            background: rgba(255, 255, 255, 1);
            border-radius: 0.57rem;
            font-size: 0.9rem;
            font-weight: 500;
            color: rgba(40, 120, 255, 1);
            line-height: 2.59rem;
        }
        .actionsheet-button:active {
            background-color: #f0f0f0;
        }
    }
    .actionsheet-modal {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 2;
        background-color: #000;
        opacity: 0.5;
    }
}
</style>

<script>
export default {
    name: "ActionSheet",
    data() {
        return {
            show: false,
            showWrapper: false
        }
    },
    props: {
        actions: {
            type: Array
        }
    },
    methods: {
        close() {
            localStorage.setItem("bann", "")
            this.show = false
            setTimeout(() => {
                this.showWrapper = false
            }, 220)
        },
        open() {
            localStorage.setItem("bann", "true")
            this.showWrapper = true
            this.show = true
        },
        itemClick(item, index) {
            if (item.method && typeof item.method === "function") {
                item.method(item, index)
            }
        }
    }
}
</script>
